// src/pages/ClientData/components/MovementsSection.js
import React from 'react';
import CollapsibleSection from './CollapsibleSection';
import MovementsTable from './MovementsTable';

const MovementsSection = ({
  processCode,
  movimentosState,
  loading,
  error,
  onLoadMovements,
  movementFiles,
  movementFilesLoading,
  movementFilesErrors,
  onLoadFiles,
  fileTranscriptions,
  fileTranscriptionLoading,
  fileTranscriptionErrors,
  fileSaving,
  onSetFileTranscriptionText,
  onTranscreverFicheiro,
  onSalvarFicheiro
}) => {
  const movimentos = movimentosState?.data || [];
  const paginacao = movimentosState?.pagination;
  const temMaisPaginas = paginacao && paginacao.current_page < paginacao.last_page;

  return (
    <CollapsibleSection title="Movimentos do Processo" icon="📋" defaultOpen={false} level={2}>
      {movimentos.length === 0 && (
        <button
          type="button"
          className="action-btn load-btn"
          onClick={() => onLoadMovements(processCode, 1)}
          disabled={loading}
        >
          {loading ? '⌛ A carregar...' : '⬇️ Carregar movimentos'}
        </button>
      )}

      {error && <div className="error-message">{error}</div>}

      {movimentos.length > 0 && (
        <>
          <MovementsTable
            processCode={processCode}
            movimentos={movimentos}
            movementFiles={movementFiles}
            movementFilesLoading={movementFilesLoading}
            movementFilesErrors={movementFilesErrors}
            onLoadFiles={onLoadFiles}
            fileTranscriptions={fileTranscriptions}
            fileTranscriptionLoading={fileTranscriptionLoading}
            fileTranscriptionErrors={fileTranscriptionErrors}
            fileSaving={fileSaving}
            onSetFileTranscriptionText={onSetFileTranscriptionText}
            onTranscreverFicheiro={onTranscreverFicheiro}
            onSalvarFicheiro={onSalvarFicheiro}
          />

          {temMaisPaginas && (
            <button
              type="button"
              className="action-btn load-btn cd-load-more"
              onClick={() => onLoadMovements(processCode, paginacao.current_page + 1)}
              disabled={loading}
            >
              {loading ? '⌛ A carregar...' : `⬇️ Carregar mais (${movimentos.length}/${paginacao.total})`}
            </button>
          )}
        </>
      )}
    </CollapsibleSection>
  );
};

export default MovementsSection;
